// src/components/doctor/AssessmentStep.jsx
//
// Step 1 — diagnosis (required to sign), optional codes, the advice the patient
// will read, and a private note. Presentational: the form lives in useConsultation.

import React from 'react';
import { VisibleToPatient, PrivateTag, RequiredTag } from './ConsultTags';
import { fmtDate } from '../../hooks/useConsultation';

export default function AssessmentStep({
  form, setField, locked, notes, noteDraft, setNoteDraft, noteSaving, onSaveNote, visitTagLength, onNext,
}) {
  return (
    <section className="card consult-work" aria-labelledby="consult-step-title">
      <h2 className="consult-work__title" id="consult-step-title" tabIndex={-1}>Assessment</h2>
      <div className="consult-work__why">What you found and what the patient should know. Autosaved — move between steps freely.</div>

      <div className="consult-field">
        <div className="consult-field__head"><label className="form-label" htmlFor="visit-dx">Diagnosis</label>
          <span className="consult-tags"><VisibleToPatient />{!locked && <RequiredTag />}</span></div>
        <textarea id="visit-dx" className="form-textarea" style={{ minHeight: 92 }} disabled={locked} value={form.diagnosisText}
          onChange={e => setField('diagnosisText', e.target.value)} placeholder="Working or final diagnosis" />
      </div>

      <div className="consult-field">
        <div className="consult-field__head">
          <label className="form-label" htmlFor="visit-codes">Diagnosis codes <span className="consult-opt">· optional</span></label>
          <PrivateTag />
        </div>
        <input id="visit-codes" className="form-input" disabled={locked} value={form.diagnosisCodes}
          onChange={e => setField('diagnosisCodes', e.target.value)} placeholder="Comma separated, e.g. E11.9, I10" />
      </div>

      <div className="consult-field">
        <div className="consult-field__head"><label className="form-label" htmlFor="visit-advice">Advice for the patient</label><VisibleToPatient /></div>
        <textarea id="visit-advice" className="form-textarea" style={{ minHeight: 104 }} disabled={locked} value={form.adviceForPatient}
          onChange={e => setField('adviceForPatient', e.target.value)}
          placeholder="Plain-language advice the patient will read after you sign" />
      </div>

      <div className="consult-field">
        <div className="consult-field__head"><label className="form-label" htmlFor="consult-note">Private note</label><PrivateTag>Private · care team only</PrivateTag></div>
        {notes.map(n => (
          <div key={n.id} className="field-group">
            <div className="field-text">{n.content.slice(visitTagLength + 1).trim()}</div>
            <div className="card-row-meta">{n.authorName} · {fmtDate(n.createdAt)}</div>
          </div>
        ))}
        <textarea id="consult-note" className="form-textarea" style={{ minHeight: 56 }} value={noteDraft} onChange={e => setNoteDraft(e.target.value)}
          placeholder="For your own records — not for the patient" />
        <button type="button" className="btn btn-secondary btn-sm" style={{ marginTop: 8 }} disabled={noteSaving || !noteDraft.trim()} onClick={onSaveNote}>
          {noteSaving ? 'Saving…' : 'Save note'}
        </button>
      </div>

      <div className="consult-foot">
        <span className="card-row-meta">Step 1 of 4</span>
        <button type="button" className="btn btn-primary" onClick={onNext}>Continue: Prescription →</button>
      </div>
    </section>
  );
}
